import React from 'react';
import List from '../ui/List';

const AttendanceList = ({ attendance }) => {
    const renderRecord = (record) => (
        <li key={record.id} className="py-3 flex justify-between items-center">
            <div className="flex flex-col">
                <span className="font-semibold">{record.student}</span>
            </div>
            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${record.status === 'Present' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                {record.status}
            </span>
        </li>
    );

    return (
        <div>
            <h3 className="text-lg font-semibold mb-2">Attendance Records</h3>
            <List items={attendance} renderItem={renderRecord} />
        </div>
    );
};

export default AttendanceList;
